import { useState, useEffect } from 'react';
import MobileBottomMenu from '../Sidebar/MobileBottomMenu';
import NativeBottomNavigation from './NativeBottomNavigation';
import { Capacitor } from '@capacitor/core';
import PropTypes from 'prop-types';

const NavigationWrapper = ({ onFabClick }) => {
  const [isNative, setIsNative] = useState(false);

  useEffect(() => {
    // Check if running in Capacitor native app (not web)
    // Capacitor.isNativePlatform() returns true only on iOS/Android, not on web
    const checkPlatform = () => {
      try {
        return Capacitor.isNativePlatform();
      } catch {
        return false;
      }
    };

    setIsNative(checkPlatform());
  }, []);

  // Use native navigation in Capacitor apps, web navigation otherwise
  if (isNative) {
    return <NativeBottomNavigation onFabClick={onFabClick} />;
  }

  return <MobileBottomMenu onFabClick={onFabClick} />;
};

NavigationWrapper.propTypes = {
  onFabClick: PropTypes.func.isRequired,
};

export default NavigationWrapper;
